import { render, staticRenderFns } from "./visualizarPerfilAcesso.vue?vue&type=template&id=b9f6b9e2&"
import script from "./visualizarPerfilAcesso.vue?vue&type=script&lang=js&"
export * from "./visualizarPerfilAcesso.vue?vue&type=script&lang=js&"
import style0 from "./visualizarPerfilAcesso.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VForm,VTextField})
